<template>
  <v-container fluid>
    <div class="radio-vertical-center dl-side">
      <v-row class="row-p-5">
        <!-- <div class="download-title">Choose Download Options</div> -->
        <v-col cols="12" sm="12" class="zero-bottom-col-12">
          <div class="new-customize-test">
            <div class="border-block">
              <div class="section-title">Download:</div>
              <div class="column-inline download-option-radio">
                <div
                  class="column-radio download-radio"
                  :class="{
                    'download-radio-omr':
                      checkIsOfflineOrOFtest() && data.omr_pattern_id > 0
                  }"
                  v-for="column in downloadOptions"
                  :key="column.value"
                >
                  <div
                    class="radio-width"
                    @click="selectedDownloadOption = column.value"
                  >
                    <input
                      type="radio"
                      name="downloadOptions"
                      id="downloadOptions"
                      v-model="selectedDownloadOption"
                      :value="column.value"
                      :checked="selectedDownloadOption === column.value"
                      color="red"
                    />
                    <label :for="column.value">{{ column.text }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          class="zero-bottom-col-12"
          v-if="checkIsOfflineOrOFtest() && selectedDownloadOption === 1"
        >
          <div class="new-customize-test">
            <div class="border-block">
              <div class="section-title">Paper utilization setting:</div>
              <div class="mt-top-10 paper-row-outer">
                <div
                  class="column-inline download-option-radio radio-align-center d-flex align-items-center justify-content-center"
                >
                  
                  <div
                    class="column-radio download-radio"
                    v-for="(column, index) in columnType"
                  
                    :key="index"
                  >
                  <span class="paper-layout" v-if="index ===0">Paper Layout:</span>
                    <div
                      class="radio-width"
                      @click="isTwoColumn = column.value"
                    >
                      <input
                        type="radio"
                        name="allMandatory"
                        id="allMandatory"
                        v-model="isTwoColumn"
                        :value="column.value"
                        :checked="isTwoColumn === column.value"
                        color="red"
                      />
                      <label :for="column.value">{{ column.text }}</label>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex align-items-center justify-content-center mode-space"
                >
                  <div class="d-flex align-center check-50">
                    <v-checkbox v-model="pageBreak"></v-checkbox>
                    <span class="pr-4">Page Saver Mode</span>
                  </div>
                  <div class="d-flex align-center  check-50">
                    <v-checkbox v-model="isRoughWork"></v-checkbox>
                    <span class="pr-4">Leave Space for Rough Work</span>
                  </div>
                </div>
                
                <div class="jee-note" v-if="!data.assignment_id">
                  JEE Advanced Pattern Papers are best viewed in Full Width
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          class="zero-bottom-col-12"
          v-if="
            !CUSTOM_INSTITUTE_ID.includes(myInstitute.id) && !data.assignment_id && (selectedDownloadOption === 1 || selectedDownloadOption === 3) &&checkIsOfflineOrOFtest()
          "
        >
          <div class="new-customize-test">
            <div class="border-block">
              <div class="section-title">Font and alignment setting:</div>
              <div>
                <div class="font-apply-row">
                  <div class="label-layout">Header</div>
                  <div class="font-type-layout">
                    <v-select
                      v-model="headerFontFamily"
                      :items="fontFamilyItemHeaderFooter"
                      dense
                      outlined
                      label="Font Family"
                      hide-details="true"
                    ></v-select>
                  </div>
                  <div class="font-size-layout">
                    <v-select
                      v-model="headerFontSize"
                      :items="headerFontSizeItem"
                      label="Font Size"
                      dense
                      item-text="text"
                      item-value="value"
                      outlined
                      hide-details="true"
                    ></v-select>
                  </div>
                  <div class="align-outer">
                    <v-btn-toggle
                      v-model="headerAlignment"
                      variant="outlined"
                      divided
                      color="primary"
                    >
                      <v-btn class="align-btn" value="left">
                        <v-icon>mdi-format-align-left</v-icon>
                      </v-btn>
                      <v-btn class="align-btn" value="center">
                        <v-icon>mdi-format-align-center</v-icon>
                      </v-btn>
                      <v-btn class="align-btn" value="right">
                        <v-icon>mdi-format-align-right</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </div>
                <div class="font-apply-row">
                  <div class="label-layout">Footer</div>
                  <div class="font-type-layout">
                    <v-select
                      v-model="footerFontFamily"
                      :items="fontFamilyItemHeaderFooter"
                      dense
                      outlined
                      label="Font Family"
                      hide-details="true"
                    ></v-select>
                  </div>
                  <div class="font-size-layout">
                    <v-select
                      v-model="footerFontSize"
                      :items="footerFontSizeItem"
                      label="Font Size"
                      dense
                      outlined
                      hide-details="true"
                    ></v-select>
                  </div>
                  <div class="align-outer">
                    <v-btn-toggle
                      v-model="footerAlignment"
                      variant="outlined"
                      divided
                    >
                      <v-btn class="align-btn" value="left">
                        <v-icon>mdi-format-align-left</v-icon>
                      </v-btn>
                      <v-btn class="align-btn" value="center">
                        <v-icon>mdi-format-align-center</v-icon>
                      </v-btn>
                      <v-btn class="align-btn" value="right">
                        <v-icon>mdi-format-align-right</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </div>
                <div class="font-apply-row">
                  <div class="label-layout">Body</div>
                  <div class="font-type-layout">
                    <v-select
                      v-model="bodyFontFamily"
                      :items="fontFamilyItem"
                      dense
                      outlined
                      label="Font Family"
                      hide-details="true"
                    ></v-select>
                  </div>
                  <div class="font-size-layout">
                    <v-select
                      v-model="bodyFontSize"
                      :items="fontSizeItem"
                      label="Font Size"
                      dense
                      outlined
                      hide-details="true"
                    ></v-select>
                  </div>
                  <div class="font-size-layout">
                  <div
            class="d-flex align-center"
            v-if="
              !CUSTOM_INSTITUTE_ID.includes(myInstitute.id) &&
                !data.assignment_id &&  (selectedDownloadOption === 1 || selectedDownloadOption === 3) &&checkIsOfflineOrOFtest()
            "
          >
            <v-checkbox v-model="watermark" :checked="watermark"></v-checkbox>
            <span class="pr-4">watermark</span>
            <div class="watermark-layout-opacity" v-if="watermark">
              <v-select
                v-model="opacity"
                :items="opacityItem"
                label="Opacity"
                dense
                outlined
                hide-details="true"
              ></v-select>
            </div>
          </div>
                  </div>
                </div>
                <div class="font-apply-row">
                
              </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          class="zero-bottom-col-12"
          v-if="
             (selectedDownloadOption==4)
          "
        >
          <div class="new-customize-test">
            <div class="border-block">
              <div class="section-title">Include Test Id:</div>
              <div class="mt-top-10 paper-row-outer">
                <div
                  class="column-inline download-option-radio radio-align-center d-flex align-items-center justify-content-center"
                >
                  
                  <div
                    class="column-radio download-radio"
                    v-for="(column, index) in includeTestId"
                  
                    :key="index"
                  >
                    <div
                      class="radio-width"
                      @click="isTwoColumn = column.value"
                    >
                      <input
                        type="radio"
                        name="allMandatory"
                        id="allMandatory"
                        v-model="isTestIDFilled"
                        :value="column.value"
                        :checked="isTwoColumn === column.value"
                        color="red"
                      />
                      <label :for="column.value">{{ column.text }}</label>
                    </div>
                  </div>
                </div>                
               </div>
            
            </div>
          </div>
        </v-col>
      
      </v-row>

      <v-row class="row-p-5">
        <v-col cols="12" sm="12" class="btn-pattern">
          <div
                class="d-flex align-center"
                v-if="
                 !CUSTOM_INSTITUTE_ID.includes(myInstitute.id) &&
                    !data.assignment_id &&  
                    (selectedDownloadOption !== 4) &&
                     data.is_test_set==1
                "
              >
                <span class="pr-4">SETS</span>
                <div class="watermark-layout-opacity" >
                  <v-select
                    v-model="selectedSet"
                    :items="sets"
                    dense
                    outlined
                    hide-details="true"
                  ></v-select>
                </div>
              </div>
          <!-- <div class="font-italic" v-if="!data.assignment_id">
            JEE Advanced Pattern Papers are best viewed in Full Width
          </div> -->
          <div class="right-align btn-right mb-1">
            <v-btn
              @click="
                onClose({
                  status: false,
                  pageBreak: pageBreak,
                  data: data,
                  isTwoColumn: isTwoColumn,
                  isRoughWork,
                  download_option: selectedDownloadOption,
                  bodyFontFamily,
                  bodyFontSize,
                  footerAlignment,
                  footerFontSize,
                  footerFontFamily,
                  headerFontSize,
                  headerAlignment,
                  headerFontFamily,
                  watermark,
                  opacity,
                  isTestIDFilled,
                  selectedSet
                })
              "
              class="right-btn cust-btn"
              color="primary"
              >Download</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import CommonInstructionsContent from "@/components/student/Tests/CommonInstructionsContent.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    CommonInstructionsContent
  },
  name: "InstructionsPopup",
  props: ["onClose", "status", "data"],
  data() {
    return {
      columnType: [
        { text: "Two Column", value: 2 },
        { text: "Full Width", value: 1 }
      ],
      roughWork: [
        { text: "Leave space", value: true },
        { text: "No free space required", value: false }
      ],
      includeTestId: [
        { text: "With Test ID prefilled", value: true },
        { text: "Without Test ID prefilled", value: false }
      ],
      isTestIDFilled: true,
      isTwoColumn: 2,
      isRoughWork: false,
      pageBreak: true,
      selectedDownloadOption: 1,
      downloadOptions: [
        {
          text: this.data.assignment_id ? "A(I)ssignment" : "Test Paper",
          value: 1
        },
        { text: "Answer Key", value: 2 },
        { text: "Solution", value: 3 }
      ],
      bodyFontSize: "12",
      footerFontSize: "8",
      headerFontSize: "20",
      footerAlignment: "center",
      headerAlignment: "right",
      bodyFontFamily: "Roboto",
      footerFontFamily: "Roboto",
      headerFontFamily: "Roboto",
      fontSizeItem: ["8", "9", "10", "11", "12", "13", "14"],
      headerFontSizeItem: [
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24"
      ],
      opacityItem: [
        {value:"0.1",text:'10%'},
        {value:"0.15",text:'15%'},
        {value:"0.2",text:'20%'},
        {value:"0.25",text:'25%'},
        {value:"0.3",text:'30%'},
        {value:"0.35",text:'35%'},
        {value:"0.4",text:'40%'},
        {value:"0.45",text:'45%'},
        {value:"0.5",text:'50%'},
        {value:"0.55",text:'55%'},
        {value:"0.6",text:'60%'},
        {value:"0.65",text:'65%'},
        {value:"0.7",text:'70%'},
        {value:"0.75",text:'75%'},
        {value:"0.8",text:'80%'},
        {value:"0.85",text:'85'},
        {value:"0.9",text:'90%'},
        {value:"0.95",text:'95%'},
        {value:"1",text:'100%'},
      ],
      footerFontSizeItem: ["6", "7", "8", "9", "10", "11", "12", "13", "14"],
      fontFamilyItem: [
        { text: "Aptos", value: "aptos" },
        { text: "Arial", value: "arial" },
        { text: "Bookman Old Style", value: "BookmanOldStyle" },
        { text: "Calibri", value: "Calibri" },
        { text: "Cambria", value: "Cambria" },
        { text: "Microsoft sans-serif", value: "microsoft-sans-serif" },
       { text: "Verdana", value: "Verdana" },
        { text: "Roboto", value: "Roboto" },
        { text: "segoe Print", value: "segoe-print" },
        { text: "Tahoma", value: "tahoma" },
        { text: "Times New Roman", value: "timesnewroman" }
      ],
      fontFamilyItemHeaderFooter: [
        { text: "Aptos", value: "aptos" },
        { text: "Arial", value: "arial" },
        { text: "Bookman Old Style", value: "BookmanOldStyle" },
        { text: "Calibri", value: "Calibri" },
        { text: "Cambria", value: "Cambria" },
        { text: "Microsoft sans-serif", value: "microsoft-sans-serif" },
        { text: "Verdana", value: "Verdana" },
        { text: "Roboto", value: "Roboto" },
        { text: "segoe Print", value: "segoe-print" },
        { text: "Tahoma", value: "tahoma" },
        { text: "Times New Roman", value: "timesnewroman" }
      ],
      watermark: false,
      opacity: "0.15",
      sets: [
        {
          text: 'A',
          value: 1
        },
        { text: "B", value: 2 },
        { text: "C", value: 3 },
        { text: "D", value: 4 }
      ],
      selectedSet: 1
    };
  },
  watch: {
    status(val) {
      if (val) {
        this.isTwoColumn = 2;
        this.isRoughWork = false;
        this.selectedDownloadOption = 1;
        this.pageBreak = true;
        this.downloadOptions = [
          {
            text: this.data.assignment_id ? "A(I)ssignment" : "Test Paper",
            value: 1
          },
          { text: "Answer Key", value: 2 },
          { text: "Solution", value: 3 }
        ];
        this.downloadOptions = this.downloadOptions.filter(
          (d) => d.value !== 4
        );
        if (
          this.data.isOnlineOfflineTest &&
          (this.data.isOnlineOfflineTest.isOffline ||
            (this.data.isOnlineOfflineTest.isOnline &&
              this.data.isOnlineOfflineTest.isOffline)) &&
          !this.downloadOptions.find((d) => d.value == 4) &&
          this.data.omr_pattern_id
        ) {
          this.downloadOptions.push({ text: "OMR", value: 4 });
        }
        this.bodyFontSize = "12";
        this.footerFontSize = "8";
        this.headerFontSize = "20";
        this.footerAlignment = "center";
        this.headerAlignment = "right";
        this.bodyFontFamily = "Roboto";
        this.footerFontFamily = "Roboto";
        this.headerFontFamily = "Roboto";
        this.watermark = false;
        this.opacity = "0.15";
        this.selectedSet = 1
        if (!this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
          this.getData();
        }
      }
    }
  },
  mounted() {
    this.downloadOptions = [
      {
        text: this.data.assignment_id ? "A(I)ssignment" : "Test Paper",
        value: 1
      },
      { text: "Answer Key", value: 2 },
      { text: "Solution", value: 3 }
    ];
    this.downloadOptions = this.downloadOptions.filter((d) => d.value !== 4);
    if (
      this.data.isOnlineOfflineTest &&
      (this.data.isOnlineOfflineTest.isOffline ||
        (this.data.isOnlineOfflineTest.isOnline &&
          this.data.isOnlineOfflineTest.isOffline)) &&
      !this.downloadOptions.find((d) => d.value == 4) &&
      this.data.omr_pattern_id
    ) {
      this.downloadOptions.push({ text: "OMR", value: 4 });
    }

    this.bodyFontSize = "12";
    this.footerFontSize = "8";
    this.headerFontSize = "20";
    this.footerAlignment = "center";
    this.headerAlignment = "right";
    this.bodyFontFamily = "Roboto";
    this.footerFontFamily = "Roboto";
    this.headerFontFamily = "Roboto";
    this.watermark = false;
    this.opacity = "0.15";
    this.selectedSet = 1

    if (!this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
      this.getData();
    }
  },
  methods: {
    ...mapActions({
      getTestDownloadSettings: "testStore/getTestDownloadSettings"
    }),
    checkIsOfflineOrOFtest() {
      return (
        this.data.isOnlineOfflineTest &&
        (this.data.isOnlineOfflineTest.isOffline ||
          (this.data.isOnlineOfflineTest.isOnline &&
            this.data.isOnlineOfflineTest.isOffline))
      );
    },
    getData() {
      const reqData = {
        test_id: this.data.test_id ? this.data.test_id : this.data.id
      };
      this.getTestDownloadSettings(reqData)
        .then((res) => {
          const settings = res.settings;
          if (res) {
            this.bodyFontSize = settings.fontSize || '12';
            this.footerFontSize = settings.footer_font_size || '8';
            this.footerAlignment = settings.footer_alignment || 'center';
            this.headerAlignment = settings.header_alignment || 'right';
            this.bodyFontFamily = settings.fontFamily || 'Roboto';
            this.footerFontFamily = settings.footer_font_family || 'Roboto';
            this.headerFontFamily = settings.header_font_family || 'Roboto';
            this.headerFontSize = settings.header_font_size || '20';
            this.watermark = JSON.parse(settings.watermark) || false;
            this.opacity = settings.opacity || '0.15';
          }
        })
        .catch((err) => {});
    }
  },
  computed: {
    ...mapState("userStore", ["user", "myInstitute"])
  }
};
</script>
<style lang="scss">
.dl-side{
  .v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default{
  min-width: 59px !important;
}
}

.watermark-layout-opacity {
  width: 65px;
  .v-select__selection--comma{
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .v-select__selection--comma{
    overflow: visible !important;
  }
  .v-input__slot{
    padding-right: 0 !important;
    
  }
  .v-input__append-inner{
    padding-left: 0px !important;
  }
}
</style>
<style lang="scss" scoped>
.new-customize-test {
  .border-block {
    border: 1px solid #000;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 15px;
    .column-radio {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .section-title {
      font-size: 15px;
      font-weight: 500;
      color: #000;
    }
  }
}
.zero-bottom-col-12 {
  padding-bottom: 0px;
  padding-top: 0px;
}
.radio-align-center {
  display: flex;
  align-items: center;
}
</style>
<style lang="scss">
.mode-space {
  .v-input__slot {
    margin-bottom: 0px !important;
  }
  .v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
  }
  .v-messages.theme--light {
    display: none;
  }
}
.paper-layout {
  margin-right: 10px;
  font-weight: 500;
  white-space: nowrap;
}
.download-option-radio {
  min-height: 30px;
  .column-radio.download-radio {
    input {
      margin-top: 5px;
    }
  }
}
.jee-note {
  font-style: italic;
  font-size: 14px;
  font-weight: 500;
  color: #0175ff;
  margin-top: 10px;
}
.font-apply-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 5px;
  .label-layout {
    font-weight: 500;
    min-width: 60px;
  }
  .font-type-layout {
    width: 120px;
  }
  .font-size-layout {
    width: 120px;
    margin-left: 10px;
  }
}
.mt-top-10 {
  margin-top: 3px;
}
.align-outer {
  margin-left: 10px;
}
.align-btn {
  height: 40px !important;
}
.v-btn--active {
  background-color: #303f9f !important;
  border-color: #303f9f !important;
  .v-icon {
    color: #fff !important;
  }
}

.btn-pattern {
  min-height: 68px;
  .v-messages {
    display: none;
  }
  .v-input--selection-controls.v-input--checkbox {
    margin-top: 0px;
    padding-top: 0px;
    .v-input__slot {
      margin-bottom: 0px;
    }
  }
}
.row-p-5 {
  padding: 0 5px;
}
.new-customize-test .border-block {
  .paper-row-outer{
    .column-radio{
      width: 50%;
    }
    .mode-space{
      .check-50{
         width: 49%;
         min-width: 49%;
      }
    }
  }
}
@media all and (max-width: 767px){
  .new-customize-test .border-block {
    .paper-row-outer{
      .paper-layout {
        min-width: 100%;
        margin-bottom: 15px;
      }
      .column-radio{
        width: 100%;
        flex-wrap: wrap;
        margin-top: 3px;
        margin-bottom: 3px;
      }
      .mode-space{
        flex-wrap: wrap;
        .check-50{
          width: 100%;
          min-width: 100%;
          margin-top: 3px;
          margin-bottom: 3px;
        }
      }
    }
  }
  .font-apply-row{
    flex-wrap: wrap;
    .label-layout{
      min-width: 100%;
      margin-bottom: 10px;
    }
    .align-outer{
      margin-left: 0px;
    }
  }
}
</style>
